import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import trainningschduleService from "./trainningschduleService";

export const getTrainningSchdules = createAsyncThunk(
  "trainningschdule/get-trainningschdules",
  async (thunkAPI) => {
    try {
      return await trainningschduleService.getTrainningSchdule();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteATrainningSchdules = createAsyncThunk(
  "trainningschdule/delete-trainningschdule",
  async (id, thunkAPI) => {
    try {
      return await trainningschduleService.deleteEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getATrainningschdule = createAsyncThunk(
  "trainningschdule/get-a-trainningschdule",
  async (id, thunkAPI) => {
    try {
      return await trainningschduleService.getEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateATrainningschdule = createAsyncThunk(
  "trainningschdule/update-trainningschdule",
  async (enq, thunkAPI) => {
    try {
      return await trainningschduleService.udpateEnquiry(enq);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  trainningschdule: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const trainningschduleSlice = createSlice({
  name: "trainningschdule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTrainningSchdules.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTrainningSchdules.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.trainningschdules= action.payload;
      })
      .addCase(getTrainningSchdules.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteATrainningSchdules.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteATrainningSchdules.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEnquiry = action.payload;
      })
      .addCase(deleteATrainningSchdules.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getATrainningschdule.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getATrainningschdule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enqName = action.payload.name;
        state.enqMobile = action.payload.mobile;
        state.enqEmail = action.payload.email;
        state.enqComment = action.payload.comment;
        state.enqStatus = action.payload.status;
      })
      .addCase(getATrainningschdule.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateATrainningschdule.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateATrainningschdule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedEnquiry = action.payload;
      })
      .addCase(updateATrainningschdule.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default trainningschduleSlice.reducer;
